export const DashboardEn = {
    dashboard: {
        menu: {
            label: {
                all: "ALL APPS",
                work: "WORK+",
                hrm: "HRM+",
                other: "OTHER+"
            }
        },
        changeLanguage: {
            title: 'Change language',
            description: 'The language you just selected is {{ deviceLang }}, but your account is currently using {{ userLang }}. Which language would you like to use?',
            use: 'Use {{ userLang }}',
            keep: 'Keep {{ deviceLang }}',
            vi: 'Vietnamese',
            en: 'English',
            de: 'Deutsch',
            "updateLanguage": "The display language has been updated because your account was recently changed to {{ updateLang }}"
        },
        notification: {
            message: "Please allow notifications to receive alerts",
            button: {
                yes: "Agree",
                no: "Disagree"
            }
        }
    }
}